import React, { useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import { ContentGrid, Grid2, Grid3 } from "../styles";
import { Card, Button, Field, Toggle, Pill, Modal, Otp6 } from "../components";
import Icon from "../components/Icon";

const SecurityView = (props) => {
  const [showPwdOld, setShowPwdOld] = useState(false);
  const [showPwdNew, setShowPwdNew] = useState(false);
  const [showPwdNew2, setShowPwdNew2] = useState(false);
  const {
    statusTwoFA,
    setStatusTwoFA,
    handleSendTwoFactor,
    twoFA,
    setTwoFA,
    emailOtp,
    setEmailOtp,
    otpMethod,
    setOtpMethod,
    authEnrolled,
    setAuthEnrolled,
    otpPolicy,
    setOtpPolicy,
    otpThreshold,
    setOtpThreshold,
    pwdOld,
    setPwdOld,
    pwdNew,
    setPwdNew,
    pwdNew2,
    setPwdNew2,
    overallRisk,
    needPasswordOtp,
    pushToast,
    uid,
    setAudit,
    otpOpen,
    setOtpOpen,
    otpCode,
    setOtpCode,
    otpWait,
    otpSentAt,
    setOtpSentAt,
    pwdOtpOpen,
    setPwdOtpOpen,
    pwdOtp,
    setPwdOtp,
    pwdOtpWait,
    pwdOtpCooldownSec,
    pwdOtpSentAt,
    setPwdOtpSentAt,
    authEnrollOpen,
    setAuthEnrollOpen,
    codesOpen,
    setCodesOpen,
    codes,
    setCodes,
    codesRevealed,
    setCodesRevealed,
    makeBackupCodes,
    email,
    tfaVerifyOpen,
    setTfaVerifyOpen,
    tfaVerifyCode,
    setTfaVerifyCode,
    tfaVerifyPending,
    setTfaVerifyPending,
    tfaSetupUrl,
    setTfaSetupUrl,
    handle2FAChange,
    handleTfaVerifySubmit,
    securityLoading,
    handleRequestPasswordOtp,
    handlePasswordConfirm,
    handlePasswordUpdateNoOtp,
  } = props;

  const pwdToggle = (show, setShow) => (
    <button
      type="button"
      onClick={() => setShow((s) => !s)}
      title={show ? "Hide password" : "Show password"}
      style={{
        display: "grid",
        placeItems: "center",
        width: 34,
        height: 34,
        borderRadius: 12,
        border: "1px solid rgba(92,233,255,.14)",
        background: "rgba(255,255,255,.06)",
        color: "rgba(240,250,255,.85)",
        cursor: "pointer",
        padding: 0,
      }}
    >
      <Icon name={show ? "eye-off" : "eye"} />
    </button>
  );

  return (
    <ContentGrid>
      <Card title="Authentication" icon="lock" right={<Pill tone="d">OTP: {otpMethod === "email" ? "Email" : "Authenticator"}</Pill>}>
        <ContentGrid>
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
            <button
              onClick={() => {
                setOtpMethod("email");
                pushToast("Security", "OTP method set to Email");
                setAudit((s) => [{ id: uid(), ts: "2026-01-08 09:06", actor: "user", type: "Security", detail: "OTP method: Email", severity: "low" }, ...s]);
              }}
              style={{
                padding: "8px 10px",
                borderRadius: 999,
                border: "1px solid rgba(92,233,255,.12)",
                background: otpMethod === "email" ? "linear-gradient(90deg, rgba(92,233,255,.22), rgba(0,247,210,.12))" : "rgba(255,255,255,.04)",
                color: "rgba(240,250,255,.92)",
                cursor: "pointer",
                fontWeight: 900,
                fontSize: 12,
              }}
            >
              Email OTP
            </button>
            <button
              onClick={() => {
                if (!authEnrolled) {
                  setAuthEnrollOpen(true);
                  pushToast("Security", "Authenticator not enrolled — setup required");
                  setAudit((s) => [{ id: uid(), ts: "2026-01-08 09:06", actor: "user", type: "Security", detail: "Authenticator setup opened", severity: "med" }, ...s]);
                  return;
                }
                setOtpMethod("auth");
                pushToast("Security", "OTP method set to Authenticator");
                setAudit((s) => [{ id: uid(), ts: "2026-01-08 09:06", actor: "user", type: "Security", detail: "OTP method: Authenticator", severity: "low" }, ...s]);
              }}
              style={{
                padding: "8px 10px",
                borderRadius: 999,
                border: "1px solid rgba(92,233,255,.12)",
                background: otpMethod === "auth" ? "linear-gradient(90deg, rgba(92,233,255,.22), rgba(0,247,210,.12))" : "rgba(255,255,255,.04)",
                color: "rgba(240,250,255,.92)",
                cursor: "pointer",
                fontWeight: 900,
                fontSize: 12,
              }}
            >
              Authenticator OTP
            </button>
            <Pill tone={overallRisk >= 45 ? "b" : "d"}>Resend: {overallRisk >= 45 ? "180s" : "60s"}</Pill>
            <Pill tone={otpPolicy === "risk" ? "c" : "d"}>Policy: {otpPolicy === "risk" ? "Risk ≥ " + otpThreshold : "Always"}</Pill>
          </div>

          <Toggle
            label="Two Factor (login OTP)"
            checked={statusTwoFA}
            onChange={(v) => (handleSendTwoFactor ? handleSendTwoFactor(v) : (setStatusTwoFA(v), pushToast("Security", v ? "Two Factor enabled" : "Two Factor disabled")))}
            disabled={securityLoading}
            hint="Requires OTP at login when enabled"
          />
          <Toggle
            label="2FA Authenticator"
            checked={twoFA}
            onChange={(v) => (handle2FAChange ? handle2FAChange(v) : (setTwoFA(v), pushToast("Security", v ? "2FA enabled" : "2FA disabled")))}
            disabled={securityLoading}
            hint="Authenticator app (scan QR code)"
          />
        </ContentGrid>
      </Card>

      <Card title="Password" icon="key" right={<Pill tone="d">Policy: 12+ chars • 1 symbol • no reuse</Pill>}>
        <Grid3>
          <Field
            label="Current password"
            value={pwdOld}
            onChange={setPwdOld}
            type={showPwdOld ? "text" : "password"}
            right={pwdToggle(showPwdOld, setShowPwdOld)}
          />
          <Field
            label="New password"
            value={pwdNew}
            onChange={setPwdNew}
            type={showPwdNew ? "text" : "password"}
            right={pwdToggle(showPwdNew, setShowPwdNew)}
          />
          <Field
            label="Confirm new"
            value={pwdNew2}
            onChange={setPwdNew2}
            type={showPwdNew2 ? "text" : "password"}
            right={pwdToggle(showPwdNew2, setShowPwdNew2)}
          />
        </Grid3>
        <div style={{ display: "flex", justifyContent: "space-between", marginTop: 12, gap: 10, flexWrap: "wrap" }}>
          <Pill tone={needPasswordOtp ? "c" : "d"}>{needPasswordOtp ? "OTP required" : "No OTP required"}</Pill>
          <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
            <Button
              variant="sec"
              onClick={() => {
                setPwdOld("");
                setPwdNew("");
                setPwdNew2("");
                pushToast("Password", "Fields cleared");
              }}
            >
              Clear
            </Button>
            <Button
              onClick={() => {
                if (!pwdOld || !pwdNew) return pushToast("Password", "Fill current + new password");
                if (pwdNew !== pwdNew2) return pushToast("Password", "New passwords do not match");
                // if (pwdNew.length < 12) return pushToast("Password", "Password too short (min 12)");

                if (!needPasswordOtp) {
                  if (handlePasswordUpdateNoOtp) {
                    handlePasswordUpdateNoOtp();
                  } else {
                    pushToast("Password", "Password updated successfully (no OTP required)");
                    setPwdOld("");
                    setPwdNew("");
                    setPwdNew2("");
                    setAudit((s) => [{ id: uid(), ts: "2026-01-08 09:03", actor: "user", type: "Security", detail: "Password updated (no OTP required)", severity: "low" }, ...s]);
                  }
                  return;
                }

                setPwdOtp("");
                if (handleRequestPasswordOtp) {
                  handleRequestPasswordOtp();
                } else {
                  setPwdOtpOpen(true);
                  if (otpMethod === "email") {
                    setPwdOtpSentAt(Date.now());
                    pushToast("Security", "Email OTP sent to confirm password change (cooldown " + pwdOtpCooldownSec + "s)");
                  } else if (!authEnrolled) {
                    setAuthEnrollOpen(true);
                    pushToast("Security", "Authenticator not enrolled — setup required");
                  } else {
                    pushToast("Security", "Use your Authenticator code to confirm password change");
                  }
                }

                if (overallRisk >= 75 && !emailOtp) pushToast("Risk Engine", "High risk detected — step-up OTP recommended");
              }}
              icon="check"
            >
              Update
            </Button>
          </div>
        </div>
      </Card>

      <Card title="Backup Codes" icon="key" right={<Button variant="sec" onClick={() => setCodesOpen(true)}>Open</Button>}>
        <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
          <Pill>One-time reveal</Pill>
          <Pill tone="c">Revoke + regenerate</Pill>
          <Pill tone="b">Store offline</Pill>
        </div>
      </Card>

      {/* OTP Modal */}
      <Modal
        open={otpOpen}
        title="Email OTP Verification"
        onClose={() => setOtpOpen(false)}
        footer={
          <>
            <Button variant="ghost" onClick={() => setOtpOpen(false)}>
              Cancel
            </Button>
            <Button
              onClick={() => {
                const ok = otpCode.replace(/[^0-9]/g, "").length >= 6;
                if (!ok) return pushToast("OTP", "Insert the 6-digit code");
                pushToast("Security", "OTP verified");
                setOtpOpen(false);
                setAudit((s) => [{ id: uid(), ts: "2026-01-08 09:00", actor: "user", type: "Security", detail: "OTP verified", severity: "low" }, ...s]);
              }}
            >
              <Icon name="check" /> Confirm
            </Button>
          </>
        }
      >
        <ContentGrid>
          <div style={{ fontSize: 12, color: "rgba(210,235,245,.78)" }}>
            We sent a one-time code to: <b style={{ color: "rgba(240,250,255,.92)" }}>{email}</b>
          </div>
          <Otp6 label="OTP code" value={otpCode} onChange={setOtpCode} />
          <div style={{ display: "flex", gap: 10, justifyContent: "space-between", alignItems: "center", flexWrap: "wrap" }}>
            <Pill tone="d">Resend available in {Math.ceil(otpWait / 1000)}s</Pill>
            <Button
              variant="sec"
              disabled={otpWait > 0}
              onClick={() => {
                setOtpSentAt(Date.now());
                setOtpCode("");
                pushToast("OTP", "New code sent");
                setAudit((s) => [{ id: uid(), ts: "2026-01-08 09:00", actor: "system", type: "Security", detail: "OTP resent", severity: "low" }, ...s]);
              }}
            >
              Resend
            </Button>
          </div>
        </ContentGrid>
      </Modal>

      {/* 2FA Verification Modal (enable/disable) */}
      {tfaVerifyOpen && (
        <Modal
          open={tfaVerifyOpen}
          title={tfaVerifyPending === "enable" ? "Enable 2FA" : "Disable 2FA"}
          onClose={() => {
            setTfaVerifyOpen(false);
            setTfaVerifyCode("");
            if (setTfaVerifyPending) setTfaVerifyPending(null);
            if (setTfaSetupUrl) setTfaSetupUrl("");
          }}
          footer={
            <>
              <Button
                variant="ghost"
                onClick={() => {
                  setTfaVerifyOpen(false);
                  setTfaVerifyCode("");
                  if (setTfaVerifyPending) setTfaVerifyPending(null);
                  if (setTfaSetupUrl) setTfaSetupUrl("");
                }}
              >
                Cancel
              </Button>
              <Button onClick={() => handleTfaVerifySubmit?.()} disabled={securityLoading}>
                <Icon name="check" /> Confirm
              </Button>
            </>
          }
        >
          <ContentGrid>
            {tfaVerifyPending === "enable" && tfaSetupUrl && (
              <>
                <div style={{ fontSize: 12, color: "rgba(210,235,245,.78)", marginBottom: 8 }}>
                  Scan the QR code with your Authenticator app, or enter the secret key manually.
                </div>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 12, marginBottom: 16 }}>
                  <div style={{ padding: 16, background: "#fff", borderRadius: 12 }}>
                    <QRCodeSVG value={tfaSetupUrl} size={180} level="H" />
                  </div>
                  {(() => {
                    const m = tfaSetupUrl.match(/secret=([^&]+)/i);
                    const secret = m ? m[1] : null;
                    return secret ? (
                      <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                        <span style={{ fontSize: 12, color: "rgba(210,235,245,.78)" }}>Secret key:</span>
                        <code
                          style={{
                            padding: "6px 10px",
                            background: "rgba(0,0,0,.3)",
                            borderRadius: 8,
                            fontSize: 11,
                            fontFamily: "ui-monospace, monospace",
                            wordBreak: "break-all",
                            cursor: "pointer",
                          }}
                          title="Click to copy"
                          onClick={() => {
                            navigator.clipboard?.writeText(secret);
                            pushToast("Security", "Secret key copied");
                          }}
                        >
                          {secret.length > 20 ? `${secret.slice(0, 10)}...${secret.slice(-8)}` : secret}
                        </code>
                      </div>
                    ) : null;
                  })()}
                </div>
              </>
            )}
            <div style={{ fontSize: 12, color: "rgba(210,235,245,.78)" }}>
              {tfaVerifyPending === "enable"
                ? "Enter the 6-digit code from your authenticator app to enable Two-Factor Authentication."
                : "Enter the 6-digit code from your authenticator app to disable Two-Factor Authentication."}
            </div>
            <Otp6 label="Code" value={tfaVerifyCode} onChange={setTfaVerifyCode} />
          </ContentGrid>
        </Modal>
      )}

      {/* Password Change OTP Modal */}
      <Modal
        open={pwdOtpOpen}
        title="Confirm Password Change"
        onClose={() => setPwdOtpOpen(false)}
        footer={
          <>
            <Button variant="ghost" onClick={() => setPwdOtpOpen(false)}>
              Cancel
            </Button>
            <Button
              onClick={() => handlePasswordConfirm?.()}
              disabled={securityLoading}
            >
              <Icon name="check" /> Confirm
            </Button>
          </>
        }
      >
        <ContentGrid>
          <div style={{ fontSize: 12, color: "rgba(210,235,245,.78)" }}>
            {otpMethod === "email" ? (
              <>
                Enter the OTP code sent to <b style={{ color: "rgba(240,250,255,.92)" }}>{email}</b> to confirm the password change.
              </>
            ) : (
              <>Open your Authenticator app and enter the 6-digit code to confirm the password change.</>
            )}
          </div>
          <Otp6 label="OTP code" value={pwdOtp} onChange={setPwdOtp} />
          <div style={{ display: "flex", gap: 10, justifyContent: "space-between", alignItems: "center", flexWrap: "wrap" }}>
            {otpMethod === "email" ? (
              <>
                <Pill tone={pwdOtpWait > 0 ? "d" : "c"}>Resend in {Math.ceil(pwdOtpWait / 1000)}s</Pill>
                <Button
                  variant="sec"
                  disabled={pwdOtpWait > 0}
                  onClick={() => {
                    setPwdOtpSentAt(Date.now());
                    setPwdOtp("");
                    pushToast("OTP", "New OTP code sent (cooldown " + pwdOtpCooldownSec + "s)");
                    setAudit((s) => [{ id: uid(), ts: "2026-01-08 09:05", actor: "system", type: "Security", detail: "Password change OTP resent (email)", severity: "low" }, ...s]);
                  }}
                >
                  Resend OTP
                </Button>
              </>
            ) : (
              <Pill tone="d">Authenticator has no resend</Pill>
            )}
          </div>
        </ContentGrid>
      </Modal>

      {/* Authenticator Enrollment Modal */}
      <Modal
        open={authEnrollOpen}
        title="Enroll Authenticator"
        onClose={() => setAuthEnrollOpen(false)}
        footer={
          <>
            <Button variant="ghost" onClick={() => setAuthEnrollOpen(false)}>
              Later
            </Button>
            <Button
              onClick={() => {
                setAuthEnrolled(true);
                setOtpMethod("auth");
                setAuthEnrollOpen(false);
                pushToast("Security", "Authenticator enrolled (demo)");
                setAudit((s) => [{ id: uid(), ts: "2026-01-08 09:08", actor: "user", type: "Security", detail: "Authenticator enrolled", severity: "med" }, ...s]);
              }}
            >
              <Icon name="check" /> Mark as enrolled
            </Button>
          </>
        }
      >
        <ContentGrid>
          <div style={{ fontSize: 12, color: "rgba(210,235,245,.78)" }}>Scan QR with your Authenticator app. (Demo placeholder)</div>
          <div style={{ height: 180, borderRadius: 16, border: "1px dashed rgba(92,233,255,.22)", background: "rgba(0,0,0,.20)", display: "grid", placeItems: "center", color: "rgba(210,235,245,.72)" }}>QR Placeholder</div>
          <ContentGrid>
            <Pill tone="c">Secret: CUST-XXXX-XXXX</Pill>
            <div style={{ fontSize: 12, color: "rgba(210,235,245,.68)" }}>After setup, confirm with a 6-digit code (hook your backend later).</div>
          </ContentGrid>
        </ContentGrid>
      </Modal>

      {/* Backup Codes Modal */}
      <Modal
        open={codesOpen}
        title="Backup Codes (one-time reveal)"
        onClose={() => {
          setCodesOpen(false);
          setCodesRevealed(false);
        }}
        footer={
          <>
            <Button
              variant="sec"
              onClick={() => {
                const text = codes.join("\n");
                navigator.clipboard?.writeText(text);
                pushToast("Backup Codes", "Copied to clipboard");
              }}
              disabled={!codesRevealed}
              title="Copy codes"
              icon="copy"
            >
              Copy
            </Button>
            <Button
              variant="danger"
              onClick={() => {
                setCodes(makeBackupCodes());
                setCodesRevealed(false);
                pushToast("Backup Codes", "Codes revoked & regenerated");
                setAudit((s) => [{ id: uid(), ts: "2026-01-08 09:01", actor: "user", type: "Security", detail: "Backup codes regenerated", severity: "med" }, ...s]);
              }}
              title="Revoke and generate new"
            >
              Revoke & regenerate
            </Button>
            <Button
              onClick={() => {
                setCodesRevealed(true);
                pushToast("Backup Codes", "Revealed — store offline");
                setAudit((s) => [{ id: uid(), ts: "2026-01-08 09:02", actor: "user", type: "Security", detail: "Backup codes revealed", severity: "med" }, ...s]);
              }}
            >
              Reveal
            </Button>
          </>
        }
      >
        <ContentGrid>
          <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
            <Pill tone="b">Do not share</Pill>
            <Pill tone="c">Each code works once</Pill>
            <Pill tone="d">Store offline</Pill>
          </div>
          {!codesRevealed ? (
            <div style={{ borderRadius: 16, border: "1px dashed rgba(92,233,255,.22)", padding: 14, background: "rgba(0,0,0,.20)", color: "rgba(210,235,245,.78)" }}>
              Codes are hidden. Click <b style={{ color: "rgba(240,250,255,.92)" }}>Reveal</b> to show them once.
            </div>
          ) : (
            <Grid2>
              {codes.map((c) => (
                <div key={c} style={{ padding: "10px 12px", borderRadius: 14, border: "1px solid rgba(92,233,255,.12)", background: "rgba(255,255,255,.03)", fontFamily: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, Liberation Mono, monospace", fontWeight: 900 }}>
                  {c}
                </div>
              ))}
            </Grid2>
          )}
        </ContentGrid>
      </Modal>
    </ContentGrid>
  );
};

export default SecurityView;
